import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService } from 'primeng/api';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { lucideCopy, lucideCircleCheck } from '@ng-icons/lucide';
import { CustomToastService } from '../../services/custom-toast.service';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [
    CommonModule,
    ToastModule,
    ProgressBarModule,
    TooltipModule,
    NgIconComponent,
  ],
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss',
  viewProviders: [provideIcons({ lucideCopy, lucideCircleCheck })],
})
export class CustomToastComponent implements OnInit, OnDestroy {
  @Input() key: string | undefined;
  @Input() position:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right'
    | 'center' = 'top-center';
  @Input() positionType: 'absolute' | 'relative' = 'absolute';
  @Input() customContentClass: string = '';
  @Input() customContentStyle: { [key: string]: any } = {};
  @Input() life: number = 3000;
  @Input() closable: boolean = true;
  @Input() copyEnabled: boolean = true;

  progress = 0;
  transitionDuration = 0;
  private subscriptions: any[] = [];
  private progressTimer: any;

  constructor(
    private messageService: MessageService,
    private customToastService: CustomToastService
  ) {}

  ngOnInit() {
    const sub = this.messageService.messageObserver.subscribe((message) => {
      if (message && !Array.isArray(message)) {
        const duration = message.life || this.life;

        if (message.severity === 'success') {
          this.progress = 0;
          this.transitionDuration = duration - 400;
          this.progressTimer = setTimeout(() => (this.progress = 100), 10);
        }
      }
    });
    this.subscriptions.push(sub);
  }

  onToastClose(event: any) {
    if (this.progressTimer) {
      clearTimeout(this.progressTimer);
      this.progressTimer = null;
    }
    this.progress = 0;

    if (event?.message) {
      this.customToastService.removeMessage({
        severity: event.message.severity,
        summary: event.message.summary,
        detail: event.message.detail
      });
    }
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    if (this.progressTimer) {
      clearTimeout(this.progressTimer);
    }
  }
}
